module.exports = __webpack_public_path__ + "img/adviceFeedback.0ccc7506.svg";